export default {
    updatedAt: {
        type: "Dayjs",
    },
};
